import type React from "react";

// Out of sight, but read by screen readers and search engines: a page heading
// the design already shows another way (a panel title, a live start page).
// Inline (not a class) so it also holds in prerendered HTML before any
// stylesheet class could match it.
export const VISUALLY_HIDDEN: React.CSSProperties = {
  position: "absolute",
  width: 1,
  height: 1,
  margin: -1,
  padding: 0,
  overflow: "hidden",
  clip: "rect(0 0 0 0)",
  clipPath: "inset(50%)",
  whiteSpace: "nowrap",
  border: 0,
};
